import Swiper from 'swiper/bundle';

if ($('.js-sliderSolutions').length > 0) {
  let ww = $(window).width(),
    margin = 16,
    sliderSolutionsElem = $('.js-sliderSolutions');
    // startSlide = 0;

  $(window).on('load', function() {
    if (ww >= 1024) {
      if (sliderSolutionsElem.find('.js-sliderOffset').length > 0) {
        margin = sliderSolutionsElem.find('.js-sliderOffset').offset().left;

        sliderSolutionsMargin(margin);

        $(window).on('resize', function() {
          margin = sliderSolutionsElem.find('.js-sliderOffset').offset().left;
          sliderSolutionsMargin(margin);
        });
      }

      // if (sliderSolutionsElem.hasClass('js-positionLeft')) {
      //   const slides = sliderSolutionsElem.find('.swiper-slide').length;
      //   startSlide = Math.floor(slides / 2) - 1;
      // }
    }

    function sliderSolutionsMargin(margin) {
      sliderSolutionsElem.css('margin-right', -margin);
    }

    let sliderSolutions = new Swiper('.js-sliderSolutions .swiper-container', {
      slidesPerView: "auto",
      // spaceBetween: 16,
      // slidesOffsetAfter: 16,
      // slidesOffsetBefore: 16,
      navigation: {
        nextEl: '.js-sliderSolutions .js-sliderNext',
        prevEl: '.js-sliderSolutions .js-sliderPrev',
      },
      scrollbar: {
        el: '.js-sliderSolutions .swiper-scrollbar',
        hide: false,
        draggable: true,
      },
      breakpoints: {
        1024: {
          slidesOffsetAfter: margin,
          slidesOffsetBefore: 0,
          // spaceBetween: 24,
        }
      }
    });
  });
}